import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { map, switchMap, catchError, first } from 'rxjs';
import { ColmecPimConceptsService, PimProductConcept } from '../../services/colmec-pim-concepts.service';
import { ColmecConceptProductsListConfigService } from '../../services/colmec-concept-products-list-config.service';
import { PimConcept } from 'gung-standard';

@Component({
  selector: 'colmec-concept-details',
  templateUrl: './colmec-concept-details.component.html',
  styleUrls: ['./colmec-concept-details.component.scss'],
  standalone: false
})
export class ColmecConceptDetailsComponent implements OnInit {
  pimProductConcept: PimProductConcept;

  private route = inject(ActivatedRoute);
  private colmecPimConceptsService = inject(ColmecPimConceptsService);
  public configService = inject(ColmecConceptProductsListConfigService);

  ngOnInit(): void {
    this.route.params
      .pipe(
        map(params => params.productId as string),
        switchMap(productId =>
          forkJoin({
            concept: this.colmecPimConceptsService.getConceptById(productId),
            products: this.colmecPimConceptsService.getProductsByConceptById(productId).pipe(
              first(),
              catchError(() => of([]))
            )
          })
        )
      )
      .subscribe(({ concept, products }) => {
        if (!concept.images || concept.images.length === 0) {
          const productWithImage = products.find(
            (p: any) => p.extra?.images?.[0]?.s3Uri && p.extra.images[0].s3Uri !== 'images/no-image.jpg'
          );
          if (productWithImage) {
            concept.images = (productWithImage as any).extra.images;
          }
        }
        this.pimProductConcept = concept;
        this.configService.concept = concept as unknown as PimConcept;
      });
  }
}
